import React from 'react'
import cx from 'classnames'

interface IconProps extends React.HTMLProps<HTMLSpanElement> {
  group: 'unicon' | 'dripicon' | 'fontawesome' | 'lineawesome'
  icon: string
  className?: string
}

const ICON_GROUP_PREFIX = {
  unicon: 'uil',
  dripicon: 'dripicons',
  fontawesome: 'fas fa',
  lineawesome: 'las la'
}

const Icon = ({ group, icon, className, ...props }: IconProps) => {
  const iconClass = `${ICON_GROUP_PREFIX[group]}-${icon}`
  return <i className={cx(iconClass, className)} {...props} />
}

export default Icon
